import { render, staticRenderFns } from "./select-age.vue?vue&type=template&id=35618d9e&"
import script from "./select-age.vue?vue&type=script&lang=js&"
export * from "./select-age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports